<template>
    <!--    拨打电话弹窗-->
    <Popup :value="show" :close-on-click-overlay="false" class="telephone">
        <div class="box">
            <div class="message">{{ phone }}</div>
            <div class="group-btn">
                <Button class="btn cancel" @click="$emit('cancel')">{{ cancelButtonText }}</Button>
                <Button class="btn confirm" :class="{'studio-btn': isStudio}" @click="callTel">{{confirmButtonText}}</Button>
            </div>
        </div>
    </Popup>
</template>

<script>
    import {Popup, Button} from 'vant';


    export default {
        name: 'Confirm',
        props: {
            show: Boolean,
            phone: {
                type: String,
                default: '110'
            },
            confirmButtonText: {
                type: String,
                default: '拨打'
            },
            cancelButtonText: {
                type: String,
                default: '取消'
            },
            isStudio: {
                type: Boolean,
                default: false
            }

        },
        data: function () {
            return {}
        },
        methods: {
            callTel() {
                this.$emit('call', this.phone)
            },
        },
        components: {Popup, Button}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .telephone {
        border-radius: 5px;
        .box {
            width: 295px;
            padding: 20px 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
            .message {
                padding-top: 30px;
                padding-bottom: 40px;
                font-size:30px;
                font-weight:400;
                color:rgba(34,34,34,1);
            }
            .group-btn {
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: space-between;

                .btn {
                    width: 114px;
                    height: 40px;
                    border-radius: 20px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 16px;
                }

                .cancel {
                    color: #6B7993;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(107, 121, 147, 1);
                    border: 1px solid #969FA9;
                }

                .confirm {
                    background: #FF5555;
                    border: none;
                    font-size: 16px;
                    font-weight: 400;
                    color:rgba(255,255,255,1);
                    &.studio-btn {
                        background: #F9DC49;
                        color: #222222;
                    }
                }
            }
        }
    }

</style>
